/**
 * Rapport de la génération des feuilles de brouillon d'un exercice de SKILLCARD
 * (`auto-sheets.ts`). Fichier léger : la page de la carte l'importe sans charger le moteur.
 */

export interface AutoSheetReport {
  questions: number;
  /** feuilles du noyau publiées */
  published: number;
  /** dont jouées aussi par le moteur v2 */
  packs: number;
  /** à revoir dans l'éditeur des feuilles */
  review: number;
  /** hors du champ du moteur (question de cours…) */
  ineligible: number;
  /** question reliée à aucune SKILLCARD publiée */
  notLinked: number;
  failed: number;
  /** erreur bloquante qui a arrêté le lot */
  stopped: string | null;
}

/** Une phrase pour l'admin. */
export function autoSheetSummary(r: AutoSheetReport): string {
  if (!r.questions && r.stopped) return `Feuilles de brouillon non générées : ${r.stopped}`;
  const parts = [
    `Feuilles de brouillon : ${r.published} / ${r.questions} publiées`,
    r.packs ? `${r.packs} sur le nouveau moteur` : null,
    r.review ? `${r.review} à revoir` : null,
    r.ineligible ? `${r.ineligible} hors champ` : null,
    r.notLinked ? `${r.notLinked} sans SKILLCARD publiée` : null,
    r.failed ? `${r.failed} en échec` : null,
  ].filter(Boolean);
  const text = parts.join(' · ') + '.';
  return r.stopped ? `${text} Arrêt : ${r.stopped}` : text;
}
